import { s3ProgressConfig } from "../utils/uploadProgress";
import type { Template, TemplateSearchResponse } from "../types/template.types";
import { api } from "./axiosClient";
import axios from "axios";

export const templateApi = {
  searchTemplate: async (payload: any) => {
    const response = await api.post<TemplateSearchResponse>(
      "/template/Search",
      payload,
    );
    return response.data;
  },

  initUpload: async (ids: string[]) => {
    const response = await api.post("/template/initupload", { ids });
    return response.data;
  },

  uploadToS3: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: { "Content-Type": file.type },
    });
  },

  uploadMedia: async (templateId: string, medias: any[]) => {
    const body = {
      templateId: templateId,
      medias: medias,
    };
    return await api.post("/template/uploadmedia", body);
  },

  getMediaLink: async (
    ids: string[],
    size: number = 1,
    groupId?: string,
  ): Promise<{ links: Array<{ id: string; link: string }> }> => {
    const response = await api.post("/template/getmedialink", {
      ids,
      size,
      groupId,
    });
    return response.data;
  },

  createTemplate: async (data: Partial<Template>) => {
    const response = await api.post("/template/create", data);
    return response.data;
  },

  updateTemplate: async (data: Partial<Template>) => {
    const response = await api.post("/template/edit", data);
    return response.data;
  },

  activateTemplate: async (id: string) => {
    return await api.post("/template/changeStatus", {
      templateId: id,
      isActive: true,
    });
  },

  deActivateTemplate: async (id: string) => {
    return await api.post("/template/changeStatus", {
      templateId: id,
      isActive: false,
    });
  },
  /** Soft delete; the reason is required and kept on the template's audit trail. */
  removeTemplate: async (id: string, reason: string) => {
    return await api.post("/template/remove", { id, reason });
  },
};
